import React from 'react';
import clsx from 'clsx';
import {InternalFieldsetStyled, Label, Legend} from './styled';

type FieldsetProps = {
  isActivated: boolean;
  isFocused: boolean;
  label?: string | React.ReactNode | null;
  legend?: string;
  isEmpty?: boolean;
  invalid?: boolean;
  htmlFor?: string;
  onClick?: () => void;
  className?: string;
};
function Fieldset({
  isActivated,
  isFocused,
  isEmpty,
  invalid,
  label,
  legend,
  onClick,
  htmlFor,
  className,
  ...props
}: FieldsetProps) {
  return (
    <>
      <Label
        htmlFor={htmlFor}
        $isEmpty={isEmpty}
        $isFocused={isFocused}
        onClick={onClick}
        $isInvalid={invalid}
        className={clsx(
          'fieldset__label',
          'kiosko:!top-7 kiosko:!left-7 kiosko:text-kiosko-s',
          {
            'fieldset__label--focused': isFocused,
            'fieldset__label--empty': isEmpty,
            'fieldset__label--invalid': invalid,
            'kiosko:!top-[-26px] kiosko:!left-[26px]': !isEmpty || (isEmpty && isFocused),
          },
        )}
      >
        {label}
      </Label>
      <InternalFieldsetStyled
        $invalid={invalid}
        $isFocused={isFocused}
        $active={isActivated}
        className={clsx('fieldset', className, 'kiosko:rounded-[14px]', {
          'fieldset--focused': isFocused,
          'fieldset--empty': isEmpty,
          'fieldset--invalid': invalid,
        })}
        {...props}
      >
        <Legend
          hidden={!label}
          $active={isActivated}
          $isEmpty={isEmpty}
          className={clsx('fieldset__legend', 'kiosko:ml-4')}
        >
          {Boolean(legend || typeof label === 'string') && (
            <span className="kiosko:text-kiosko-s">{legend || label}</span>
          )}
        </Legend>
      </InternalFieldsetStyled>
    </>
  );
}

export {Fieldset};
